if (!customElements.get('dz-bf-announcement')) {
  customElements.define('dz-bf-announcement', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.isConnected || this.controller) return;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (!this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.messages = this.querySelector('[data-messages]');
      this.counter = this.querySelector('[data-counter]');
      this.autoEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.holds = new Set();
      this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.hold('hover', true);
      }, options);
      this.addEventListener('pointerleave', () => this.hold('hover', false), options);
      this.addEventListener('focusin', () => this.hold('focus', true), options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.hold('focus', false);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.messages.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch') return;
        this.touchStart = { x: event.clientX, y: event.clientY };
        this.hold('touch', true);
      }, options);
      this.messages.addEventListener('pointerup', event => {
        if (!this.touchStart) return;
        const dx = event.clientX - this.touchStart.x;
        const dy = event.clientY - this.touchStart.y;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.suppressClickUntil = Date.now() + 400;
          this.show(this.index + (dx < 0 ? 1 : -1));
        }
        this.touchStart = null;
        this.hold('touch', false);
      }, options);
      this.messages.addEventListener('pointercancel', () => {
        this.touchStart = null;
        this.hold('touch', false);
      }, options);
      this.messages.addEventListener('click', event => {
        if (Date.now() < (this.suppressClickUntil || 0)) event.preventDefault();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', event => {
        if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
        const index = this.slides.findIndex(slide => slide.dataset.blockId === String(event.detail.blockId));
        if (index < 0) return;
        this.hold('editor', true);
        this.show(index);
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (String(event.detail?.sectionId) === this.dataset.sectionId) this.hold('editor', false);
      }, options);
      this.dataset.ready = '';
      this.show(0);
    }
    hold(reason, active) {
      if (active) this.holds.add(reason);
      else this.holds.delete(reason);
      this.schedule();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
      if (this.counter) this.counter.textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const running = this.autoEnabled && !this.motion.matches && !this.holds.size && !document.hidden;
      this.messages.setAttribute('aria-live', running ? 'off' : 'polite');
      if (running) this.timer = setTimeout(() => this.show(this.index + 1), Math.max(3000, Number(this.dataset.speed) || 6000));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
